import React from 'react';
import PropTypes from 'prop-types';
import { Provider } from 'react-redux';
import { ApolloProvider } from 'react-apollo';
import { createIntlCache, IntlProvider } from 'react-intl';
import { updateIntl } from 'react-intl-redux';
import MessagesContainer from '../../../../containers/MessagesContainer';
import client from '../../../../lib/apolloClient';
import configureStore from '../../../../store/findBobPublicStore';
import translations from '../../../../lib/i18n/translations.json';
const defaultLocale = 'en';
const defaultMessages = translations[defaultLocale];

/**
 * LegacyFallback - Fallback to existing messaging system
 * 
 * This component renders the existing MessagesContainer when the 
 * findbob_modernization feature flag is disabled, ensuring 
 * zero breaking changes for existing users.
 */
const LegacyFallback = (props) => {
  // Ensure store exists - follow the same pattern as ChatWidgetContainer
  let store = document.store;
  if (!store) {
    store = configureStore(props);
    document.store = store;
  }

  // Setup internationalization - follow the same pattern as ChatWidgetContainer
  const cache = createIntlCache();
  const setIntl = () => {
    updateIntl(
      {
        locale: defaultLocale,
        messages: translations[window.locale || defaultLocale] || defaultMessages,
      },
      cache
    );
  };
  setIntl();

  return (
    <Provider store={store}>
      <IntlProvider messages={translations[window.locale || defaultLocale] || defaultMessages} locale={window.locale || defaultLocale}>
        <ApolloProvider client={client}>
          <MessagesContainer {...props} />
        </ApolloProvider>
      </IntlProvider>
    </Provider>
  );
};

LegacyFallback.propTypes = {
  currentUser: PropTypes.object,
  // All props are passed through to MessagesContainer
};

export default LegacyFallback; 